import { mutatorAction } from 'satcheljs';
import getStore from './store/store';

const setUserPremiumStatusMutator: (calculatedPremiumStatus: boolean) => void = mutatorAction(
    'setUserPremiumStatus',
    (calculatedPremiumStatus: boolean) => {
        getStore().userPremiumStatus = calculatedPremiumStatus;
    }
);

export function setUserPremiumStatus(calculatedPremiumStatus: boolean): void {
    setUserPremiumStatusMutator(calculatedPremiumStatus);
}
